import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { GeoLocationService } from './core/services/geolocation.service';
import { CommonService } from './core/services/common.service';
import { ScriptInjectorService } from './core/services/script-injector.service';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { PreviewOverlayComponent } from './components/preview-overlay/preview-overlay.component';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { HeaderFooterService } from './core/services/header-footer.service';
import { QueryStringService } from './core/services/query-string.service';
import { ProgramDataService } from './core/services/program-data.service';
import { ScrollRestorationService } from './core/services/scroll-restoration.service';
import { PartnerDataService } from 'khegm-ui-components';
import { NinetailedService } from './core/services/ninetailed.service';
import { Subscription, filter, skip } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    PreviewOverlayComponent,
    RouterModule,
  ]
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy{
  siteName!: string;
  private routerSub?: Subscription;
  
  constructor(
    private geoLocation: GeoLocationService,
    private commonService: CommonService,
    private scrollService: ScrollRestorationService,
    private headerService: HeaderFooterService,
    private qspService: QueryStringService,
    private scriptService: ScriptInjectorService,
    private partner: PartnerDataService,
    private programDataService: ProgramDataService,
    private ninetailedService: NinetailedService,
    private router: Router
  ) {}
  
  ngOnInit(): void {
    this.siteName = this.programDataService.siteName;
    const apiBasePath = this.programDataService.getAPIBasePath();
    const sourceQSP = this.qspService.getParameter('source');
    this.partner.setPartnerData(apiBasePath + '/core', sourceQSP, this.siteName);
    this.headerService.getDefaultSiteConfiguration();
    if (this.commonService.isPlatformBrowser()) {
      this.ninetailedService.initialize();
      // skip(1) avoids a duplicate page() call — initialize() already triggers the initial page() internally
      this.routerSub = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd), skip(1))
        .subscribe(() => {
          this.ninetailedService.page();
        });
    }
  }

  ngAfterViewInit(): void {
    if(this.commonService.isPlatformBrowser()) {
      this.geoLocation.setLocation();
      const qsp = this.qspService.getFullQspString();
      if (qsp) {
        this.qspService.appendQspOnCookieBanner();
      }
      this.scrollService.listenToNavigationEvents();
    }
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

}
